import { utils as XLSXutils, write as XLSXwrite } from "xlsx";
import { ReserveStockData } from "../Data/reserveStock";
import { OrderLists } from "../res/type";

export const exportToExcel = (data: ReserveStockData[], baseFileName: string) => {
  if (!data || data.length === 0) {
    console.error("No data available for export.");
    return;
  }

  const headers = ["Item_No", "Item_Name", "QTY", "PRICE", "COMMENT"];
  const now = new Date();
  const currentDate = now.toISOString().slice(0, 10);
  const currentTime = now.toTimeString().slice(0, 8).replace(/:/g, "");
  const rowCount = data.length;
  const fileName = `${baseFileName}_${currentDate}_${currentTime}_${rowCount}rows.xlsx`;
  const formattedData = data.map((item) => ({
    Item_No: item.sku,
    Item_Name: item.item_name,
    QTY: item.shipping,
    PRICE: "", // Assuming PRICE is not available in the data
    COMMENT: "", // Assuming COMMENT is not available in the data
  }));

  // Create a new worksheet with the headers and formatted data
  const worksheet = XLSXutils.json_to_sheet(formattedData, { header: headers, skipHeader: false });

  // Add a row of headers at the top
  XLSXutils.sheet_add_aoa(worksheet, [headers], { origin: "A1" });

  // Create a new workbook and add the worksheet
  const workbook = XLSXutils.book_new();
  XLSXutils.book_append_sheet(workbook, worksheet, "Data");

  // Write the workbook to a Blob and initiate download
  const excelBuffer = XLSXwrite(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  a.click();
  window.URL.revokeObjectURL(url);
};

export const exportOrderToExcel = (data: OrderLists[], baseFileName: string) => {
  if (!data || data.length === 0) {
    console.error("No data available for export.");
    return;
  }

  const headers = [
    "ORDER",
    "TRACKING",
    "CATEGORY",
    "PLATEFORM",
    "PLATEFORM_STATUS",
    "LOGISTIC",
    "BRAND",
    "STATUS",
    "BATCH_NO",
    "BATCH_DATE",
    "INVOICE",
    "SO_NO",
    "TOTAL_PRICE",
  ];

  const now = new Date();
  const currentDate = now.toISOString().slice(0, 10); // Format: YYYY-MM-DD
  const currentTime = now.toTimeString().slice(0, 8).replace(/:/g, ""); // Format: HHMMSS
  const rowCount = data.length;
  const fileName = `${baseFileName}_${currentDate}_${currentTime}_${rowCount}rows.xlsx`;

  // Map the data to the format required for the Excel file
  const formattedData = data.map((item) => ({
    ORDER: item.order_no,
    TRACKING: item.tracking_no,
    CATEGORY: item.category,
    PLATEFORM: item.platform,
    PLATEFORM_STATUS: item.platform_status,
    LOGISTIC: item.logistic,
    BRAND: item.brand,
    STATUS: item.operation_status,
    BATCH_NO: item.batch_id,
    BATCH_DATE: item.batch_create_date,
    INVOICE: item.invoice_no,
    SO_NO: item.so_no,
    TOTAL_PRICE: item.total_price,
  }));

  // Create a new worksheet with the headers and formatted data
  const worksheet = XLSXutils.json_to_sheet(formattedData, { header: headers, skipHeader: false });

  // Add a row of headers at the top
  XLSXutils.sheet_add_aoa(worksheet, [headers], { origin: "A1" });

  // Create a new workbook and add the worksheet
  const workbook = XLSXutils.book_new();
  XLSXutils.book_append_sheet(workbook, worksheet, "Data");

  // Write the workbook to a Blob and initiate download
  const excelBuffer = XLSXwrite(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  a.click();
  window.URL.revokeObjectURL(url);
};
